// THIS FILE IS AUTO GENERATED
var GenIcon = require('../lib').GenIcon;

module.exports.FiLifeBuoy = function FiLifeBuoy(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "10"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "4"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4.93",
        "y1": "4.93",
        "x2": "9.17",
        "y2": "9.17"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14.83",
        "y1": "14.83",
        "x2": "19.07",
        "y2": "19.07"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14.83",
        "y1": "9.17",
        "x2": "19.07",
        "y2": "4.93"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14.83",
        "y1": "9.17",
        "x2": "18.36",
        "y2": "5.64"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4.93",
        "y1": "19.07",
        "x2": "9.17",
        "y2": "14.83"
      }
    }]
  })(props);
};